var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',_vm._b({ref:"paymentForm",staticClass:"paymentWidgets",attrs:{"action":_vm.url,"data-brands":_vm.dataBrands}},'form',_vm.$attrs,false))])}
var staticRenderFns = []

export { render, staticRenderFns }